// extracted by mini-css-extract-plugin
export var label = "ArticleMeta-module--label--KHZar";
export var row = "ArticleMeta-module--row--+aoP4";